import React from 'react';

import PropTypes from 'prop-types';

import { t } from 'i18next';

import './style.scss';

const Spinner = ({position = 'fixed' , width = '100vw', height = '100vh'}) => {
  return (
    <>
    <div className='body-blocker' style={{position, width, height}}></div>
    <div className="spinner-container" style={{position, width, height}}>
      <div className="spinner">
        <div className="dot main" />
        <div className="dot trail trail-1" />
        <div className="dot trail trail-2" />
        <div className="dot trail trail-3" />

        <div className="dot main opposite" />
        <div className="dot trail trail-1 opposite" />
        <div className="dot trail trail-2 opposite" />
        <div className="dot trail trail-3 opposite" />
      </div>
      <div className="loading-text">{t('LOADING')}...</div>
    </div>
    </>
  );
};

export default Spinner;

Spinner.propTypes = {
  position: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};